import { graphql } from 'react-apollo';
import { assignmentSession } from 'chameleon/packages/blue-book-player/queries/assignmentSession';

const withSession = graphql(assignmentSession, {
  options: ({ assignmentId, isImpersonating = false }) => ({
    variables: {
      assignmentId: Number.parseInt(assignmentId, 10),
      isImpersonating,
    },
    fetchPolicy: 'network-only',
  }),
  props: ({
    data: { loading, assignmentSession: assignmentSessionData, error, refetch },
  }) => {
    let props = {
      isAssignmentSessionLoading: loading,
      assignmentError: {
        hasError: !!error,
        message: (error || {}).message,
      },
    };

    if (!loading && !error && assignmentSessionData) {
      const { timedSession } = assignmentSessionData;
      props.checkTimeExtension = refetch;

      if (timedSession) {
        props.timerInfo = timedSession;
      }
    }

    return props;
  },
});

export default withSession;
